import { Card, CardContent } from '@mlm/ui';
import type { KpiCardData } from '../../lib/api';
import { formatPeso } from './format';
import { TenantWideBadge } from './tenant-wide-badge';

/**
 * Standing cash liability: the total members could cash out right now (sum of
 * every slot's materialized CASH balance). Unlike the "This month" flows, this
 * is a snapshot — no delta or sparkline. It includes imported opening balances
 * by design, because it answers "if everyone cashed out today, how much cash do
 * we owe?".
 */
export function CirculatingWallet({
  wallet,
  filtered = false,
}: {
  wallet?: KpiCardData;
  filtered?: boolean;
}) {
  return (
    <Card>
      <CardContent className="p-6">
        <div className="flex items-baseline justify-between gap-4">
          <div>
            <div className="flex items-center gap-1.5">
              <p className="text-caption uppercase tracking-[0.1em] font-medium text-muted-foreground">
                Circulating wallet
              </p>
              <TenantWideBadge show={filtered && wallet?.scope === 'tenant'} />
            </div>
            <p className="mt-1 text-kpi tabular-nums text-foreground">
              {wallet ? formatPeso(wallet.value) : '0.00'}
            </p>
          </div>
          <p className="max-w-[15rem] text-right text-body text-muted-foreground">
            Cash members could cash out right now
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
